export const FormRadio: React.FC<{
  field: {name: string; value: any; onChange: () => void}
  form: {
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  }
  gValue: string
  gName: string
  label: string
  setRelateField?: string
  defaultChecked?: boolean
  disabled?: boolean
}> = (props) => {
  return (
    <label className='d-flex align-items-center justify-content-between cursor-pointer mb-6'>
      <span className='form-check form-check-custom form-check-solid'>
        <input
          type='radio'
          className='form-check-input'
          name={props.gName}
          value={props.gValue}
          disabled={props.disabled}
          checked={props.field.value === props.gValue}
          onChange={(val) => {            
            val && props.form.setFieldValue(props.field.name, props.gValue)
            props.setRelateField && props.form.setFieldValue(props.setRelateField, props.label)
          }}
        />
        <span className='d-flex align-items-center ms-5'>
          <span className='fs-6'>{props.label}</span>
        </span>
      </span>
    </label>
  )
}
